import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements OnInit, ControlValueAccessor, OnChanges {
  @ViewChild('select', { static: true }) select: ElementRef<HTMLInputElement> | undefined;

  @Input() label?: string;
  @Input() msgError?: string;
  @Input() isBlue?: boolean;
  @Input() list: any[] = [];
  @Input() listDisplay?: string;
  @Input() readonly = false;
  @Input() required = false;
  @Input() innerValue: any = null;
  @Input() disabled = false;
  @Input() white_background = false;
  @Input() fixBottom = false;
  @Input() strictMatch = true;
  @Input() sortAlphabetically = false;
  @Input() modalSelector = false;
  @Input() branchId?: string;
  @Output() selectedItem: EventEmitter<any> = new EventEmitter();
  @Output() dataInput: EventEmitter<any> = new EventEmitter();

  focus = false;
  result: any[] = [];
  dataShow = false;
  display = false;
  modalVisible = false;
  private _value: any;

  constructor() { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement) {
    if (!target.classList.contains('selectRes')) this.dataShow = false;
    if (!target.classList.contains('color')) this.display = false;
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    this.result = this.sortAlphabetically
      ? this.list.slice().sort((a, b) => this.getNormalizedText(a).localeCompare(this.getNormalizedText(b)))
      : this.list;
  }

  validate(): boolean {
    if (this.required) {
      const validation = this.listDisplay
        ? this.value?.[this.listDisplay]
        : !!this.value;
      this.msgError = validation ? '' : 'Campo requerido';
    }
    return !this.msgError;
  }

  filter(e: Event) {
    const element = e.currentTarget as HTMLInputElement;
    const inputValue = this.normalizeText(element.value);
    this.dataInput.emit(element.value);

    let filtered = this.list.filter(item =>
      this.normalizeText(this.listDisplay ? item[this.listDisplay] : item).startsWith(inputValue)
    );

    if (filtered.length === 0 && inputValue.length > 0) {
      filtered = this.list.filter(item =>
        this.normalizeText(this.listDisplay ? item[this.listDisplay] : item).includes(inputValue)
      );
    }

    this.result = this.sortAlphabetically
      ? filtered.slice().sort((a, b) => this.getNormalizedText(a).localeCompare(this.getNormalizedText(b)))
      : filtered;
  }

  focusEv() {
    if (this.modalSelector) {
      this.openAdvancedSelector();
      return;
    }
    if (!this.readonly) {
      this.focus = true;
      this.dataShow = true;
    }
  }

  focusoutEv() {
    this.focus = false;
    if (!this.strictMatch) return;

    const currentText = this.select?.nativeElement.value?.trim() || '';
    const isMatch = this.result.some(item =>
      this.normalizeText(this.listDisplay ? item[this.listDisplay] : item) === this.normalizeText(currentText)
    );

    if (!isMatch) this.clearSelection();
  }

  toggleListDisplay() {
    if (this.modalSelector) {
      this.openAdvancedSelector();
      return;
    }
    this.display = !this.display;
  }

  selectItem(val: any) {
    this.value = val;
    this.selectedItem.emit(val);
    this.dataShow = false;
    this.result = this.list;
    this.display = false;
  }

  selectItemFromModal(item: any) {
    this.value = item;
    this.selectedItem.emit(item);
    this.closeAdvancedSelector();
  }

  clearSelection() {
    if (this.select) this.select.nativeElement.value = '';
    this._value = undefined;
    this.selectedItem.emit(null);
  }

  openAdvancedSelector() {
    this.modalVisible = true;
  }

  closeAdvancedSelector() {
    this.modalVisible = false;
  }

  get value() {
    return this._value;
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  onChange(_: any) { }
  onTouch() { }

  writeValue(obj: any): void {
    this._value = obj;

    this.inputValue = this.listDisplay ? obj?.[this.listDisplay] ?? '' : obj ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  private normalizeText(text: any): string {
    if (typeof text !== 'string') {
      text = text?.toString?.() ?? '';
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  }

  private getNormalizedText(item: any): string {
    const text = this.listDisplay ? item[this.listDisplay] : item;
    return this.normalizeText(text?.toString());
  }
  belongsToBranch(id: string): boolean {
    return this.branchId === id;
  }
  get inputValue(): string {
    const raw = this.listDisplay
      ? this._value?.[this.listDisplay]
      : this._value;

    if (!raw) return '';
    return this.modalSelector ? this.toTitleCase(raw.toString()) : raw.toString();
  }

  private toTitleCase(text: string): string {
    return text.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }


  set inputValue(val: string) {
    // No hacemos nada aqu�, el valor se controla desde selectItem o filter
  }
}
